import { unsafeChinese } from '@lazy-cjk/util';

export { unsafeChinese }
